export default __webpack_public_path__ + "static/media/trivia-challenge.8bec772f.png";